/**
 * Used for identifying primitives.
 *
 * @internal
 */
export const KIND: unique symbol = Symbol.for("Alepha.Kind");
